import { Component, OnInit } from '@angular/core';
import {
  AuthService,
  AvailabilityService,
  CartListComponent,
  CartService,
  Customer,
  GungFlow,
  GungFlowService,
  PriceService,
  ProductService,
  SelectedCustomerService
} from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { first } from 'rxjs';

@Component({
    selector: 'cult-cart-list',
    templateUrl: './cult-cart-list.component.html',
    styleUrls: ['./cult-cart-list.component.scss'],
    standalone: false
})
export class CultCartListComponent extends CartListComponent implements OnInit {
  public currentFlow: GungFlow;
  isReturNoPrice = false;
  currentCustomer: Customer;

  constructor(
    protected productService: ProductService,
    protected cartService: CartService,
    protected priceService: PriceService,
    protected availabilityService: AvailabilityService,
    protected dateUtilService: DateUtilService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected selectedCustomerService: SelectedCustomerService
  ) {
    super(productService, cartService, priceService, availabilityService, dateUtilService);
  }

  ngOnInit(): void {
    this.selectedCustomerService.getSelectedCustomer().pipe(first()).subscribe(currentCustomer => {
      this.currentCustomer = currentCustomer;
      super.ngOnInit();
      this.gungFlowService
        .getSelectedFlow()
        .pipe(first())
        .subscribe(currentFlow => {
          this.currentFlow = currentFlow;
          //isReturnOrder
        });
      this.authService
        .getCurrentUser()
        .pipe(first())
        .subscribe(user => {
          this.isReturNoPrice = user.roles.includes('RETUR_NOPRICE');
        });
    });
  }
}
